import React, { useState, useEffect } from "react";
import { FaBell, FaArrowUp, FaArrowDown, FaUserCog } from "react-icons/fa";
import { MdPendingActions, MdDashboard } from "react-icons/md";
import { SolutionOutlined, SendOutlined, ExclamationCircleFilled, SafetyCertificateFilled } from '@ant-design/icons';
import axios from "../../services/axios";

const Dashboard = () => {
  const [notifications, setNotifications] = useState([]);
  const user = localStorage.getItem('user');
  const projectName = JSON.parse(localStorage.getItem("Project"));
  const [pendingTasks, setPendingTasks] = useState(0);
  const [pendingTasksData, setPendingTasksData] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [totalDocumentsApproved, setTotalDocumentsApproved] = useState(0);
  const [totalDocumentsApprovedData, setTotalDocumentsApprovedData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [totalDocumentsRejected, setTotalDocumentsRejected] = useState(0);
  const [totalDocumentsRejectedData, setTotalDocumentsRejectedData] = useState([]);
  const [totalMasDocuments, setTotalMasDocuments] = useState(0);
  const [totalMasApproved, setTotalMasApproved] = useState(0);
  const [totalMasApprovedData, setTotalMasApprovedData] = useState([]);
  const [totalMasRejected, setTotalMasRejected] = useState(0);
  const [totalMasRejectedData, setTotalMasRejectedData] = useState([]);
  const [totalShopDocuments, setTotalShopDocuments] = useState(0);
  const [totalShopApproved, setTotalShopApproved] = useState(0);
  const [totalShopApprovedData, setTotalShopApprovedData] = useState([]);
  const [totalShopRejected, setTotalShopRejected] = useState(0);
  const [totalShopRejectedData, setTotalShopRejectedData] = useState([]);
  const [totalUnderReview, setTotalUnderReview] = useState(0);
  const [totalToResubmit, setTotalToResubmit] = useState(0);
  const [totalToResubmitData, setTotalToResubmitData] = useState([]);
  const [totalTransmitted, setTotalTransmitted] = useState(0);
  const [totalTransmittedCorrespondences, setTotalTransmittedCorrespondences] = useState(0);
  const [forInformationCorrespondences, setForInformationCorrespondences] = useState(0);
  const [underreviewCorrespondences, setUnderreviewCorrespondences] = useState(0);
  const [respondedCorrespondences, setRespondedCorrespondences] = useState(0);
  const role = JSON.parse(localStorage.getItem('role'))[0];
  const [isLoading, setIsLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [apiCallsCompleted, setApiCallsCompleted] = useState({
    notifications: false,
    pendingTasks: false,
    totalDocuments: false,
    documentsApproved: false,
    documentsRejected: false,
    masDocuments: false,
    masApproved: false,
    masRejected: false,
    shopDocuments: false,
    shopApproved: false,
    shopRejected: false,
    underreview: false,
    toResubmit: false,
    totalTransmitted: false,
  });

  const totalUploaded = totalDocuments + totalShopDocuments + totalMasDocuments;
  const totalApproved = totalDocumentsApproved + totalShopApproved + totalMasApproved;
  const totalRejected = totalDocumentsRejected + totalShopRejected + totalMasRejected;

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.post("get-user-notifications", { user, projectName });
        setNotifications(response.data.notifications.slice(0, 5));
        setApiCallsCompleted((prev) => ({ ...prev, notifications: true }));
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setApiCallsCompleted((prev) => ({ ...prev, notifications: true }));
      }
    };
    fetchNotifications();
  }, [user, projectName, refreshKey]);


   useEffect(() => {
  if (!user || !role || !projectName) return;

  const fetchDashboardSummary = async () => {
    try {
      const { data } = await axios.post("/dashboard-summary", {
        user,
        role,
        projectName,
      });

      /* ===============================
         COUNTS
      =============================== */

      setCategoriesData(data.categoriesData || []);

      // Approved / Rejected
      setTotalDocumentsApproved(data.approved || 0);
      setTotalDocumentsRejected(data.rejected || 0);

      // Transmitted
      setTotalTransmitted(data.totalTransmitted || 0);
      setTotalTransmittedCorrespondences(
        data.totalTransmittedCorrespondences || 0
      );

      // For Information
      setPendingTasks(data.forInformation || 0);
      setForInformationCorrespondences(
        data.forInformationCorrespondences || 0
      );

      // Under Review
      setTotalUnderReview(data.underreview || 0);
      setUnderreviewCorrespondences(
        data.underreviewCorrespondences || 0
      );

      // Responded
      setRespondedCorrespondences(data.respondedCorrespondences || 0);

      // Re-submit
      setTotalToResubmit(data.toResubmit || 0);
      setTotalToResubmitData(data.documents?.resubmitDocs || []);

      /* ===============================
         OPTIONAL DOCUMENT LISTS
      =============================== */
      setTotalDocumentsApprovedData(
        data.documents?.approvedDocs || []
      );

      setTotalDocumentsRejectedData(
        data.documents?.rejectedDocs || []
      );

      setPendingTasksData(
        data.documents?.forInfoTech || []
      );

      /* ===============================
         API STATUS
      =============================== */
      setApiCallsCompleted({
        dashboard: true,
      });

    } catch (error) {

      // Safe reset
      setTotalDocumentsApproved(0);
      setTotalDocumentsRejected(0);

      setTotalTransmitted(0);
      setTotalTransmittedCorrespondences(0);

      setPendingTasks(0);
      setForInformationCorrespondences(0);

      setTotalUnderReview(0);
      setUnderreviewCorrespondences(0);

      setRespondedCorrespondences(0);

      setTotalToResubmit(0);
      setTotalToResubmitData([]);

      setApiCallsCompleted({
        dashboard: true,
      });
    }
  };

  fetchDashboardSummary();
}, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalMasDocuments = async () => {
      try {
        const response = await axios.post("mas-total-docuemnts-uploaded", { user, role, projectName });
        setTotalMasDocuments(response.data.totalMasDocuments);
        setApiCallsCompleted((prev) => ({ ...prev, masDocuments: true }));
      } catch (error) {
        console.error("Error fetching MAS documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, masDocuments: true }));
      }
    };
    fetchTotalMasDocuments();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalMasApproved = async () => {
      try {
        const response = await axios.post("mas-docuemnts-approved", { user, role, projectName });
        setTotalMasApproved(response.data.totalMasApproved);
        setTotalMasApprovedData(response.data.documents || []);
        setApiCallsCompleted((prev) => ({ ...prev, masApproved: true }));
      } catch (error) {
        console.error("Error fetching approved MAS documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, masApproved: true }));
      }
    };
    fetchTotalMasApproved();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalMasRejected = async () => {
      try {
        const response = await axios.post("mas-docuemnts-rejected", { user, role, projectName });
        setTotalMasRejected(response.data.totalMasRejected);
        setTotalMasRejectedData(response.data.documents || []);
        setApiCallsCompleted((prev) => ({ ...prev, masRejected: true }));
      } catch (error) {
        console.error("Error fetching rejected MAS documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, masRejected: true }));
      }
    };
    fetchTotalMasRejected();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalShopDocuments = async () => {
      try {
        const response = await axios.post("shop-total-docuemnts-uploaded", { user, role, projectName });
        setTotalShopDocuments(response.data.totalShopDocuments);
        setApiCallsCompleted((prev) => ({ ...prev, shopDocuments: true }));
      } catch (error) {
        console.error("Error fetching shop documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, shopDocuments: true }));
      }
    };
    fetchTotalShopDocuments();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalShopApproved = async () => {
      try {
        const response = await axios.post("shop-docuemnts-approved", { user, role, projectName });
        setTotalShopApproved(response.data.totalShopApproved);
        setTotalShopApprovedData(response.data.documents || []);
        setApiCallsCompleted((prev) => ({ ...prev, shopApproved: true }));
      } catch (error) {
        console.error("Error fetching approved shop documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, shopApproved: true }));
      }
    };
    fetchTotalShopApproved();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const fetchTotalShopRejected = async () => {
      try {
        const response = await axios.post("shop-docuemnts-rejected", { user, role, projectName });
        setTotalShopRejected(response.data.totalShopRejected);
        setTotalShopRejectedData(response.data.documents || []);
        setApiCallsCompleted((prev) => ({ ...prev, shopRejected: true }));
      } catch (error) {
        console.error("Error fetching rejected shop documents:", error);
        setApiCallsCompleted((prev) => ({ ...prev, shopRejected: true }));
      }
    };
    fetchTotalShopRejected();
  }, [user, role, projectName, refreshKey]);

  useEffect(() => {
    const allCompleted = Object.values(apiCallsCompleted).every((completed) => completed);
    if (allCompleted) {
      setIsLoading(false);
    }
  }, [apiCallsCompleted]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative inline-block">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin"></div>
          </div>
          <p className="mt-4 text-gray-600 font-medium">Loading Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 pl-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
              <MdDashboard className="text-white text-xl" />
            </div>
            Dashboard Overview
          </h1>
          
        </div>

        {/* Stats Cards */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
          
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-blue-100 rounded-lg flex items-center justify-center">
                <SendOutlined className="text-blue-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Transmitted</p>
              <p className="text-3xl font-bold text-gray-800">{totalTransmitted}</p>
              <p className="text-gray-500 text-xs">Sent to Consultant</p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-green-100 rounded-lg flex items-center justify-center">
                <SafetyCertificateFilled className="text-green-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Approved / Approved with Comments</p>
              <p className="text-3xl font-bold text-gray-800">{totalApproved}</p>
              <div className="flex items-center gap-1 text-green-600 text-xs">
                <FaArrowUp className="text-xs" />
                <span>{totalUploaded > 0 ? Math.round((totalApproved / totalUploaded) * 100) : 0}% rate</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-amber-100 rounded-lg flex items-center justify-center">
                <ExclamationCircleFilled className="text-amber-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Rejected</p>
              <p className="text-3xl font-bold text-gray-800">{totalRejected}</p>
              <div className="flex items-center gap-1 text-amber-600 text-xs">
                <FaArrowDown className="text-xs" />
                <span>{totalUploaded > 0 ? Math.round((totalRejected / totalUploaded) * 100) : 0}% rate</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-purple-100 rounded-lg flex items-center justify-center">
                <MdPendingActions className="text-purple-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">For Information</p>
              <p className="text-3xl font-bold text-gray-800">{pendingTasks}</p>
              <p className="text-gray-500 text-xs flex items-center gap-1">
                <FaUserCog className="text-xs" />
                Needs attention
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-sky-100 rounded-lg flex items-center justify-center">
                <SolutionOutlined className="text-sky-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Under Review</p>
              <p className="text-3xl font-bold text-gray-800">{totalUnderReview}</p>
              <p className="text-gray-500 text-xs">Being reviewed</p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-violet-100 rounded-lg flex items-center justify-center">
                <SendOutlined className="text-violet-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">To Re-Submit / Revise & Resubmit</p>
              <p className="text-3xl font-bold text-gray-800">{totalToResubmit}</p>
              <p className="text-gray-500 text-xs">Awaiting revision</p>
            </div>
          </div>

        </div> */}

        <div className="space-y-10">
          {categoriesData.map((cat, index) => {

            const totalUploaded =
              cat.approved +
              cat.rejected +
              cat.transmitted +
              cat.forInfo +
              cat.underReview +
              cat.resubmit;

            return (
              <div key={index}>

                {/* CATEGORY HEADING */}
                <h2 className="text-lg font-bold text-gray-800 mb-4">
                  {cat.category}
                </h2>

                {/* SAME OLD DESIGN CARDS */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">

                  {/* Transmitted */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-blue-100 rounded-lg flex items-center justify-center">
                        <SendOutlined className="text-blue-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Transmitted</p>
                      <p className="text-3xl font-bold text-gray-800">{cat.transmitted}</p>
                      <p className="text-gray-500 text-xs">Sent to Consultant</p>
                    </div>
                  </div>

                  {/* Approved */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-green-100 rounded-lg flex items-center justify-center">
                        <SafetyCertificateFilled className="text-green-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">
                        Approved / Approved with Comments
                      </p>
                      <p className="text-3xl font-bold text-gray-800">{cat.approved}</p>
                      <div className="flex items-center gap-1 text-green-600 text-xs">
                        <FaArrowUp className="text-xs" />
                        <span>
                          {totalUploaded > 0
                            ? Math.round((cat.approved / totalUploaded) * 100)
                            : 0}% rate
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Rejected */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-amber-100 rounded-lg flex items-center justify-center">
                        <ExclamationCircleFilled className="text-amber-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Rejected</p>
                      <p className="text-3xl font-bold text-gray-800">{cat.rejected}</p>
                      <div className="flex items-center gap-1 text-amber-600 text-xs">
                        <FaArrowDown className="text-xs" />
                        <span>
                          {totalUploaded > 0
                            ? Math.round((cat.rejected / totalUploaded) * 100)
                            : 0}% rate
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* For Information */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-purple-100 rounded-lg flex items-center justify-center">
                        <MdPendingActions className="text-purple-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">For Information</p>
                      <p className="text-3xl font-bold text-gray-800">{cat.forInfo}</p>
                      <p className="text-gray-500 text-xs flex items-center gap-1">
                        <FaUserCog className="text-xs" />
                        Needs attention
                      </p>
                    </div>
                  </div>

                  {/* Under Review */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-sky-100 rounded-lg flex items-center justify-center">
                        <SolutionOutlined className="text-sky-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Under Review</p>
                      <p className="text-3xl font-bold text-gray-800">{cat.underReview}</p>
                      <p className="text-gray-500 text-xs">Being reviewed</p>
                    </div>
                  </div>

                  {/* To Re-Submit */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="w-11 h-11 bg-violet-100 rounded-lg flex items-center justify-center">
                        <SendOutlined className="text-violet-600 text-lg" />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">
                        To Re-Submit / Revise & Resubmit
                      </p>
                      <p className="text-3xl font-bold text-gray-800">{cat.resubmit}</p>
                      <p className="text-gray-500 text-xs">Awaiting revision</p>
                    </div>
                  </div>

                </div>

              </div>
            );
          })}
        </div>

        <div className="mt-10 mb-6">
          <h2 className="text-lg font-bold text-gray-800 tracking-wide">
            Correspondences & Notices
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
          {/* Transmitted Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-blue-100 rounded-lg flex items-center justify-center">
                <SendOutlined className="text-blue-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Transmitted</p>
              <p className="text-3xl font-bold text-gray-800">{totalTransmittedCorrespondences}</p>
              <p className="text-gray-500 text-xs">Sent to Consultant</p>
            </div>
          </div>

          {/* For Information Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-purple-100 rounded-lg flex items-center justify-center">
                <MdPendingActions className="text-purple-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">For Information</p>
              <p className="text-3xl font-bold text-gray-800">{forInformationCorrespondences}</p>
              <p className="text-gray-500 text-xs flex items-center gap-1">
                <FaUserCog className="text-xs" />
                Needs attention
              </p>
            </div>
          </div>

          {/* Under Review Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-sky-100 rounded-lg flex items-center justify-center">
                <SolutionOutlined className="text-sky-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">Under Review</p>
              <p className="text-3xl font-bold text-gray-800">{underreviewCorrespondences}</p>
              <p className="text-gray-500 text-xs">Being reviewed</p>
            </div>
          </div>

          {/* Responded */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 bg-green-100 rounded-lg flex items-center justify-center">
                <SafetyCertificateFilled className="text-green-600 text-lg" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-gray-600 text-xs font-medium uppercase tracking-wide">
                Responded
              </p>
              <p className="text-3xl font-bold text-gray-800">
                {respondedCorrespondences}
              </p>
              <p className="text-gray-500 text-xs">Consultant replied</p>
            </div>
          </div>
        </div>

        {/* Notifications Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <FaBell className="text-red-500" />
                Recent Notifications
              </h3>
              <p className="text-sm text-gray-500 mt-1">Latest updates and alerts</p>
            </div>
          </div>
          
          <div className="space-y-3">
            {notifications.length > 0 ? (
              notifications.map((notif, index) => (
                <div key={index} className="flex items-start gap-3 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100 hover:shadow-sm transition-shadow">
                  <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <FaBell className="text-white text-xs" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-gray-800 leading-relaxed">{notif.message}</p>
                    <p className="text-xs text-gray-500 mt-1">
                      {notif.timestamp ? new Date(notif.timestamp).toLocaleString() : "Recently"}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                <FaBell className="text-5xl mb-3 opacity-20" />
                <p className="text-sm">No notifications available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;